import React from 'react';
import { Field } from 'formik';
import { Editor } from '@tinymce/tinymce-react';

import tinymceConfig from 'buyside/util/tinymceConfig';

export const NotesField = ({ field, form: { setFieldValue, isSubmitting } }) => {
  const onEditorChange = value => setFieldValue(field.name, value);

  return (
    <Editor
      disabled={isSubmitting}
      init={tinymceConfig}
      onEditorChange={onEditorChange}
      value={field.value || ''}
    />
  );
};

const NotesForm = () => <Field component={NotesField} name="fundProfile.notes" />;

export default NotesForm;
